<template>
  <div>
    <SplashSectionHero />
    <!--    <SplashSectionHowItWorks />-->
    <SplashSectionHowItWorks2 />
    <!--    <SplashSectionWheneverBet />-->
    <SplashSectionAvailableSportsAndBookmakers />

    <!--    <LandingImage />-->

    <FaqSection />

    <Hero2Section />

    <StartButtonSection />

    <HeaderLogo />

    <Footer />
  </div>
</template>

<script setup lang="ts">
import Hero2Section from '@/components/header/Hero2Section.vue'
import Footer from '@/components/footer/Footer.vue'
import StartButtonSection from '@/components/button/StartButtonSection.vue'
import HeaderLogo from '@/components/header/HeaderLogo.vue'
import SplashSectionHero from '@/components/splash/hero/SplashSectionHero.vue'
import SplashSectionAvailableSportsAndBookmakers from '@/components/splash/SplashSectionAvailableSportsAndBookmakers.vue'
import { onMounted } from 'vue'
import SplashSectionHowItWorks2 from '@/components/splash/SplashSectionHowItWorks2.vue'
import FaqSection from '@/components/faq/FaqSection.vue'

onMounted(() => {
  window.scrollTo(0, 0)
})
</script>
